let LocationSearchResults = (() => {
    let redirect = null;

    let init = () => {
        initAutoComplete();
        bindEvents();
        getPassedLocationQuery();
        getRedirectUrl();
    }

    let initAutoComplete = () => {
        let input = document.getElementById('autocomplete');
        let autocomplete = new google.maps.places.Autocomplete(input, {
            types: ['geocode']
        });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            let place = autocomplete.getPlace();
            if (place) {
                locationSearch();
            }
        });
    }

    let bindEvents = () => {

        // Need to handle both when the button is clicked and when the form is sumbmitted
        jQuery('#location-search-results-form .search-location').on('click', (e) => {
            e.preventDefault();
            sessionStorage.setItem('mjt_action_taken', 'true');
            locationSearch();
        });

        jQuery('#location-search-results-form').on('submit', (e) => {
            e.preventDefault();
            sessionStorage.setItem('mjt_action_taken', 'true');
            locationSearch();
        });

        //Use location button click
        jQuery('.location-search-results-header .use-location').on('click', (e) => {
            e.preventDefault();
            sessionStorage.setItem('mjt_action_taken', 'true');
            useMyLocation();
        });

        //Set store button click
        jQuery(document).on('click', '.results-store-buttons .monro-button-yellow, .result-buttons .monro-button-yellow, a.monro-button-red[data-makeappointment], .results-mobile-top .monro-button-yellow .make-my-store', (e) => {
            e.preventDefault();
            sessionStorage.setItem('storeSelectedInSession', 'true')
            if (e.target.getAttribute("data-makestore")) {
                Util.setCookie('dni-phone-number', e.currentTarget.getAttribute('data-dni-number'), 180)
                makeMyStoreClick(e.currentTarget);
            }
            else if (e.target.getAttribute("data-makeappointment")) {
                makeAppointmentClick(e, e.currentTarget);
            }
        });

        //Load more mobile stores on click
        jQuery(document).on('click', '.load-mobile-button', (e) => {
            e.preventDefault();
            loadFiveStores(e.currentTarget);
        });
    }

    let locationSearch = (query = jQuery('#location-search-results-form').find('input[name="LocationSearchQuery"]').val()) => {
        let url = `${window.location.origin}/wp-content/themes/understrap-child/api/geocode/geocode.php`;
        resetResults();

        jQuery.ajax({
            type: "POST",
            dataType: "json",
            url: url,
            data: {
                query: query
            },
            success: function (data) {
                var data = JSON.parse(data);
                if (data.results.length < 1) {
                    stopSpinner();
                    showSearchError('No Results Found');
                    return;
                } else {
                    findStores(data.results[0].geometry.location);
                }
            },
            error: function (xhr) {
                stopSpinner();
                showSearchError('No Results Found');
                return;
            }
        });
    }

    let useMyLocation = () => {
        if (navigator.geolocation) {
            resetResults();
            navigator.geolocation.getCurrentPosition((position) => {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                findStores(pos);
            }, (error) => {
                if (error.code == error.PERMISSION_DENIED) {
                    stopSpinner();
                    showSearchError('Please enter your address, city, or zip code.');
                    return;
                }
                stopSpinner();
                showSearchError('Could not determine location');
            });
        } else {
            stopSpinner();
            showSearchError('Could not determine location');
        }
    }

    let setStoreCookieIfBrandMatches = (storeId, brandId) => {
        if (Util.getCookie('brand_id') === brandId) {
            Util.setCookie('store_location', storeId, 180);
        }
    }

    let getUrlParamFromRedirect = () => {
        const queryString = redirect.split('?')[1];
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get('url');
    }

    let makeMyStoreClick = (button) => {
        const storeId = jQuery(button).data("storeid");
        // convert brandid attribute from integer to string to work when comparing with brand_id cookie
        const brandId = jQuery(button).data("brandid").toString();
        let targetUrl = Util.lookupBrandUrls(brandId);

        //delete appointment related cookies
        document.cookie.split(';')
            .filter(item => item.includes('appt'))
            .forEach((cookie) => {
                document.cookie = cookie + '; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
            }
            );

        //delete appointment info from session storage
        Object.keys(sessionStorage)
            .filter(key => key.includes('appointment'))
            .forEach((key) => {
                sessionStorage.removeItem(key);
            }
            );

        // if the redirect query parameter originates from the tiremake page, append only the parameter to the target URL so the tiremodel page links don't break
        if (redirect !== null && redirect.includes('/tiremake/')) {
            targetUrl += `${redirect}`
        }

        // if the redirect query parameter originates from the coupon landing page template, append the coupon URL path to the target URL
        else if (redirect !== null && redirect.includes('/coupon?url=')) {
            // Parse coupon URL value from the redirect string
            const couponUrl = getUrlParamFromRedirect();
            targetUrl += `/coupon/${couponUrl}`;
        }

        // if the redirect query parameter originates from the promotion landing page template, append the promotion URL path to the target URL
        else if (redirect !== null && redirect.includes('/promotion?url=')) {
            // Parse promotion URL value from the redirect string
            const promotionUrl = getUrlParamFromRedirect();
            targetUrl += `/promotion/${promotionUrl}`;
        }

        //if there is a redirect query parameter and it includes a query parameter initializer (?), append it to the target URL
        else if (redirect !== null && redirect.includes('?')) {
            targetUrl += `${redirect}&${Date.now().toString()}&`;
        }

        //if there is a redirect query parameter and it doesn't have '/' for a value, append query parameter initializer (?) to redirect and append to the target URL
        else if (redirect !== null && redirect !== '/') {
            targetUrl += `${redirect}?&${Date.now().toString()}&`;
        }

        else {
            // redirect query parameter is null or has '/' for a value, append query parameter initializer (?) to the target URL
            targetUrl += '?';
        }

        setStoreCookieIfBrandMatches(storeId, brandId);
        // if brand_id cookie  doesn't match store's brand id, append storeid query parameter to the target URL
        if (Util.getCookie('brand_id') !== brandId) {
            targetUrl += `storeid=${storeId}&`
        }

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            'event': 'makeStoreClick',
            'storeID': storeId,
            'journey_id': sessionStorage.getItem('mjt_journey_id'),
            'page_depth': parseInt(sessionStorage.getItem('mjt_page_depth'))
          });

        sessionStorage.setItem('mjt_action_taken', 'true');
        location.assign(targetUrl);

    }

    // Will find the group to be shown from the button data variable
    // Will set data variable for that group of mobile stores to 0 such that the scss that shows it takes effect
    // Then will set group to be shown += 1
    // the scss will make the button display: none when its data vairable reaches 5
    let loadFiveStores = (button) => {
        var num = button.getAttribute("data-shown-groups");
        jQuery(`.results-store-container-mobile[data-mobile-group=${num}]`).attr("data-mobile-group", 0);
        button.setAttribute("data-shown-groups", Number(num) + 1);
    }

    let resetResults = () => {
        jQuery('#location-results-container').html('');
        jQuery('.results-error-container').css("display", "none");
        startSpinner();
    }

    let distanceToLocation = (lat1, lng1, lat2, lng2) => {
        var earthRadiusInMiles = 3956.0;
        return earthRadiusInMiles * 2 * Math.asin(Math.min(1, Math.sqrt((Math.pow(Math.sin((diffRadian(lat1, lat2)) / 2.0), 2.0) + Math.cos(toRadian(lat1)) * Math.cos(toRadian(lat2)) * Math.pow(Math.sin((diffRadian(lng1, lng2)) / 2.0), 2.0)))));
    }

    let toRadian = (v) => {
        return v * (Math.PI / 180);
    }

    let diffRadian = (v1, v2) => {
        return toRadian(v2) - toRadian(v1);
    }

    let findStores = (pos) => {
        pos ? '' : resetResults();
        let distance = 50;
        let apiRoute = pos ? `/wp-json/monro/v1/stores/coords?latitude=${pos.lat}&longitude=${pos.lng}&distance=${distance}` : `/wp-json/monro/v1/stores/brand?brand=${Util.getCookie('brand_id')}`;
        let template = ``;
        const dniColumn = Util.getDniColumn();
        let mobileNum = 5; //number of results to generate and show for mobile on initial load
        // Note that if the number of groups changes, then the scss has to be updated to
        // [data-shown-groups="mobileGroupTotal"]{ display: none }
        // so that the button will disapear when the max number of groups is reached
        let mobileGroupTotal = 5; // number of groups of 5 stores to allow to load on mobile
        fetch(apiRoute)
            .then((response) => response.json())
            .then((stores) => {
                let storeArray = stores.data;
                if (storeArray.length >= 1) {
                    jQuery.each(storeArray, (key, value) => {
                        const phoneNumber = value[dniColumn];
                        const clickThroughPhoneNumber = `+1${phoneNumber.replace(/\D/g, '')}`;
                        //need to create store hours
                        var hours = BusinessHours.createHoursArrayKeyValue(value, true);
                        var hoursString = '';
                        Object.keys(hours).map((key) => {
                            hoursString += `<li><div class="results-store-day">${key}</div> <div class="results-store-hours">${hours[key]}</div></li>`;
                        });
                        template += `
                            <div class="results-store-container">
                                <div class="results-store-header"><div class="result-number">${key + 1}</div> ${value.BrandDisplayName}</div>
                                <p>Store #${value.Id}</p>
                                <div class="results-store-wrapper">
                                    <div class="results-store-buttons">`;
                        // if paytomorrow query parameter exists, add paytomorrow button html to template
                        if (checkForQueryParam("paytomorrow") != null) {
                            template += `
                                    <a class="monro-button appointment-button-wrapper" href="${value.ptapplicationlink}">
                                        APPLY NOW
                                    </a>`
                        }
                        else {
                            template += `
                                    <a class="monro-button monro-button-yellow" data-brandid="${value.BrandId}" data-storeid="${value.Id}" data-makestore="true" data-dni-number="${phoneNumber}">
                                        Make My Store
                                    </a>
                                    <a class="monro-button monro-button-red" href="${Util.lookupBrandUrls(value.BrandId)}/appointment/services-info?storeid=${value.Id}" data-brandid="${value.BrandId}" data-storeid="${value.Id}" data-makeappointment="true">
                                        Schedule an Appointment
                                    </a>`
                        }
                        template += `
                                    </div>
                                    <div class="results-store-info-container">
                                        <div class="results-store-info">
                                            <div class="">${value.Address}</div>
                                            <div class="">${value.City}, ${value.StateCode} ${value.ZipCode}</div>
                                            <a class="results-directions-link" href="https://www.google.com/maps/?saddr=My+Location&daddr=${value.Latitude},${value.Longitude}" target="_blank" rel="noopener noreferrer">Get Directions ${pos ? '(' + distanceToLocation(value.Latitude, value.Longitude, pos.lat, pos.lng).toFixed(2) + ' miles)' : ''}</a>
                                            <a class="results-directions-link" href="${value.WebsiteURL}" target="_blank" rel="noopener noreferrer">Store Details</a>
                                            <div class="results-store-phone"><i class="fa fa-mobile"></i> ${phoneNumber}</div>
                                        </div>
                                        <div class="results-store-hours-wrapper">
                                            <ul class="results-store-hours-list">
                                                ${hoursString}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <hr class="results-separator">
                            </div>
                        `;
                        if (key < mobileNum * mobileGroupTotal) {
                            template += `
                                <div class="results-store-container-mobile" data-mobile-group="${Math.floor(key / mobileNum)}">
                                    <div class="results-mobile-top">
                                        <div class="result-number-wrapper">
                                            <div class="result-number">${key + 1}</div>
                                        </div>
                                        <div class="result-store-details">
                                            <div class="results-store-header"> ${value.BrandDisplayName} - ${value.City} #${value.Id}</div>
                                            <div class="results-store-info-container">
                                                <div class="results-store-info">
                                                    <div class="">${value.Address}</div>
                                                    <div class="">${value.City}, ${value.StateCode} ${value.ZipCode}</div>
                                                    <a class="results-directions-link" href="https://www.google.com/maps/?saddr=My+Location&daddr=${value.Latitude},${value.Longitude}" target="_blank" rel="noopener noreferrer">Get Directions ${pos ? '(' + distanceToLocation(value.Latitude, value.Longitude, pos.lat, pos.lng).toFixed(2) + ' miles)' : ''}</a>
                                                    <a class="results-directions-link" href="${value.WebsiteURL}" target="_blank" rel="noopener noreferrer">Store Details</a>
                                                    <div class="results-store-hours">
                                                        <ul class="results-store-hours-list">
                                                            ${hoursString}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>`
                            // if paytomorrow query parameter exists, add paytomorrow button html to template
                            if (checkForQueryParam("paytomorrow") != null) {
                                template += `
                                        <div> 
                                        </div>
                                    </div>
                                    <div class="results-mobile-bottom">
                                        <div class="make-appointment-button-wrapper">
                                            <a class="monro-button appointment-button-wrapper" href="${value.ptapplicationlink}">
                                            APPLY NOW
                                            </a>
                                        </div>
                                    </div>
                                </div>`
                            }
                            else {
                                template += `
                                        <div class="result-buttons" style="${checkForQueryParam("paytomorrow") != null} ? display: none;" : "> 
                                            <a class="monro-button monro-button-yellow" data-brandid="${value.BrandId}" data-storeid="${value.Id}" data-makestore="true">
                                                SELECT
                                            </a>
                                            <a class="monro-button" href="tel:${clickThroughPhoneNumber}">
                                                <i class="fa fa-mobile"></i>
                                                CALL
                                            </a>
                                        </div>
                                    </div>
                                    <div class="results-mobile-bottom">
                                        <div class="make-appointment-button-wrapper">
                                            <a class="monro-button monro-button-red" href="/appointment/services-info?storeid=${value.Id}" data-makeappointment="true">
                                                Schedule an Appointment
                                            </a>
                                        </div>
                                    </div>
                                </div>`
                            };
                        }
                    });
                    // add the load more button for mobile
                    template += `
                        <a class="monro-button monro-button-yellow load-mobile-button" data-shown-groups="1">
                            Load More Stores
                        </a>`;

                    generateMapPins(storeArray);
                    stopSpinner();
                    jQuery('#location-results-container').append(template);
                    jQuery('.location-search-map-wrapper').css('display', 'block');
                    LocationFlyout.lookupDayOfWeek('.results-store-day', true);
                    dismissKeyboard();

                } else {
                    stopSpinner();
                    showSearchError('No Results Found');
                    dismissKeyboard();
                }
            });
    }

    // Dismisses OS keyboard for mobile devices 
    let dismissKeyboard = () => {
        document.activeElement.blur();
    }

    // element is an <a> tag with an href attribute
    let makeAppointmentClick = (e, element) => {
        e.preventDefault();
        const anchor = element.getAttribute("href");

        // will only exist if initialized on html attribute
        const storeId = jQuery(element).data("storeid");
        const brandId = jQuery(element).data("brandid");

        if (storeId && brandId) {
            setStoreCookieIfBrandMatches(storeId, brandId);
        }

        if (anchor.length > 0) {
            window.location.href = anchor;
        }
    }

    let startSpinner = () => {
        jQuery('.results-loading-container').css("display", "block");
    }

    let stopSpinner = () => {
        jQuery('.results-loading-container').css("display", "none");
    }

    let showSearchError = (err) => {
        let errMsg = `<h2>${err}</h2>`;
        jQuery('.results-error-container').css("display", "block");
        jQuery('.results-error-container').html(errMsg);
        jQuery('.location-search-map-wrapper').css('display', 'none');
    }

    let getPassedLocationQuery = () => {
        var param = checkForQueryParam('q');
        if (param != null) {
            jQuery('#location-search-results-form').find('input[name="LocationSearchQuery"]').text(param);
            jQuery('#location-search-results-form').find('input[name="LocationSearchQuery"]').val(param);
            locationSearch(param);
            return;
        } else if (checkForQueryParam('geo_fallback') !== null) {
            stopSpinner();
            showSearchError('No Results Found Within 100 Miles Of Your Location. Please enter your address, city, or zip code.');
            return;
        } else {
            //Show all stores
            findStores();
        }
    }

    let getRedirectUrl = () => {
        let param = checkForQueryParam('redirect');
        if (param !== null) {
            redirect = decodeURIComponent(param);
        }
    }

    let checkForQueryParam = (name) => {
        let value = Util.getParameterByName(name)
        return value;
    }

    let generateMapPins = (data) => {
        let mapOptions = {
            zoom: 10,
            clickableIcons: false,
            panControl: true,
            draggable: true,
            gestureHandling: 'cooperative',
            disableDefaultUI: true,
        }

        function pinSymbol(color) {
            return {
                path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
                fillColor: color,
                fillOpacity: 1,
                strokeColor: '#fff',
                strokeWeight: 1,
                scale: 1.4,
                labelOrigin: new google.maps.Point(0, -29)
            };
        }

        let markerOptions = {
            clickable: true,
            indexedPins: true,
            icon: pinSymbol('#D82C20')
        }

        AppGoogleMap.displayCollectionStoreMap(data, 'location-search-map', mapOptions, markerOptions);
    }

    return {
        init: init,
        bindEvents: bindEvents,
        makeAppointmentClick: makeAppointmentClick
    }
})();